
import {ActionTree, Module, MutationTree, GetterTree} from "vuex";
import {RootState} from "@/store/types";
import {BOMSubassemblyState, BOMSubassembly, BOMSubassemblyPagination} from "@/modules/bom_subassembly/types";
import {getSubassemblyBoms, saveBOMWithSubassemblies} from "@/services/bom_subassembly";

export const state: BOMSubassemblyState = {
    subassembly_bom: {
      valid_from: new Date(),
      valid_to: new Date()
    },
    subassembly_boms: [],
    loaded: false,
    subassembly_bom_versions_pagination: {
      page: 1,
      items_per_page: 10,
      count: 0
    }
};

const actions: ActionTree<BOMSubassemblyState, RootState> = {
    async GET_SUBASSEMBLY_BOMS(_, payload) {
      return await getSubassemblyBoms(payload);
    },
    async SAVE_SUBASSEMBLY_BOM(_, subassemblyBOM) {
      return await saveBOMWithSubassemblies(subassemblyBOM);
    }
};

const mutations: MutationTree<BOMSubassemblyState> = {
    SET_SUBASSEMBLY_BOM(state, subassembly_bom: BOMSubassembly) {
      state.subassembly_bom = subassembly_bom;
    },
    SET_SUBASSEMBLY_BOMS(state, subassembly_boms: BOMSubassembly[]) {
      state.subassembly_boms = subassembly_boms;
    },
    RESET_SUBASSEMBLY_BOMS() {
      state.subassembly_boms = [];
    },
    SET_LOADING_STATUS(state, status: boolean) {
      state.loaded = status;
    },
    SET_BOM_VERSIONS_PAGINATION(state, subassembly_bom_versions_pagination: BOMSubassemblyPagination) {
      state.subassembly_bom_versions_pagination = subassembly_bom_versions_pagination;
    }
};

const getters: GetterTree<BOMSubassemblyState, RootState> = {
    SUBASSEMBLY_BOM(state): BOMSubassembly {
      const {subassembly_bom} = state;
      return {...subassembly_bom};
    },
    SUBASSEMBLY_BOMS(state): BOMSubassembly[] {
      const {subassembly_boms} = state;
      return [...subassembly_boms];
    },
    LOADING_STATUS(state) : boolean {
      const {loaded} = state;
      return loaded;
    },
    BOM_VERSIONS_PAGINATION(state) : BOMSubassemblyPagination {
      const {subassembly_bom_versions_pagination} = state;
      return {...subassembly_bom_versions_pagination};
    }
}

export const bom_subassembly: Module<BOMSubassemblyState, RootState> = {
    actions,
    mutations,
    getters,
    state
};
